<template>
  <div id="app" :class="{'coze': iscoze}">
    <div class="bgs">

      <div class="appmains">
        <HeaderComponent></HeaderComponent>
        <el-container>
          <el-aside class="sidebar" v-if="iscoze"> 
          </el-aside>
          <el-main> 
            <router-view />
          </el-main>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
export default {
  name: "App",
  components: {
    HeaderComponent
  },
  data() {
    return {
      iscoze: false
    };
  },
  watch: {
    $route(to) {
      if (to.path == '/cozeIndex') {
        this.iscoze = false
      }
    }
  },
  mounted() {
    let path = this.$route.path
    if (path == '/cozeIndex') {
      this.iscoze = false
    }
  },


};
</script>

<style lang="scss">
*{
  box-sizing: border-box;
}
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  font-family: "SourceHanSansCN-Heavy";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background: #111318; 
  color: #fff;
  // overflow: hidden;
  // overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  
  .bgs{
    background: #111318; 
  }
  .appmains{
    width: 100%;
    min-height: 100%;
    padding-top: 70px;
    box-sizing: border-box;
    background:url("http://cdn.gugusj.com/xdk/bg11.png") no-repeat;
    background-size: 1416px auto;
    background-position:  center 400px;
    .el-container {
      width: 100%;
      height: calc(100vh - 70px);
    }
  }
.sidebar {
  width: 200px;
}  
}
.coze {
  background: url('http://cdn.gugusj.com/xdk/indexbg1.png') no-repeat top center !important;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/App.vue